function initQuncelUltraReference(root) {
  if (!root || root.dataset.qurReady === 'true') return;
  root.dataset.qurReady = 'true';

  const tabs = [...root.querySelectorAll('[data-qur-construction-tab]')];
  const panels = [...root.querySelectorAll('[data-qur-construction-panel]')];

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.qurConstructionTab;
      tabs.forEach((item) => {
        const selected = item === tab;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', String(selected));
      });
      panels.forEach((panel) => {
        const selected = panel.dataset.qurConstructionPanel === target;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      });
    });
  });

  const rangeViewport = root.querySelector('[data-qur-range-viewport]');
  const rangePrevious = root.querySelector('[data-qur-range-prev]');
  const rangeNext = root.querySelector('[data-qur-range-next]');

  if (rangeViewport && rangePrevious && rangeNext) {
    const scrollDistance = () => {
      const card = rangeViewport.querySelector('.qur-range-card');
      const gap = Number.parseFloat(getComputedStyle(rangeViewport.querySelector('.qur-range-grid')).columnGap) || 16;
      return (card?.getBoundingClientRect().width || rangeViewport.clientWidth * 0.8) + gap;
    };

    const updateControls = () => {
      const maxScroll = rangeViewport.scrollWidth - rangeViewport.clientWidth;
      rangePrevious.disabled = rangeViewport.scrollLeft <= 2;
      rangeNext.disabled = rangeViewport.scrollLeft >= maxScroll - 2;
    };

    rangePrevious.addEventListener('click', () => {
      rangeViewport.scrollBy({ left: -scrollDistance(), behavior: 'smooth' });
    });
    rangeNext.addEventListener('click', () => {
      rangeViewport.scrollBy({ left: scrollDistance(), behavior: 'smooth' });
    });
    rangeViewport.addEventListener('scroll', updateControls, { passive: true });

    let dragStart = 0;
    let scrollStart = 0;
    let dragged = false;

    rangeViewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch') return;
      dragStart = event.clientX;
      scrollStart = rangeViewport.scrollLeft;
      dragged = false;
      rangeViewport.classList.add('is-dragging');
      rangeViewport.setPointerCapture(event.pointerId);
    });
    rangeViewport.addEventListener('pointermove', (event) => {
      if (!rangeViewport.hasPointerCapture(event.pointerId)) return;
      const movement = event.clientX - dragStart;
      dragged = dragged || Math.abs(movement) > 5;
      rangeViewport.scrollLeft = scrollStart - movement;
    });
    rangeViewport.addEventListener('pointerup', (event) => {
      if (rangeViewport.hasPointerCapture(event.pointerId)) rangeViewport.releasePointerCapture(event.pointerId);
      rangeViewport.classList.remove('is-dragging');
    });
    rangeViewport.addEventListener('click', (event) => {
      if (!dragged) return;
      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    }, true);

    requestAnimationFrame(updateControls);
  }
}

// Only the split mattress range: also initialise after editor-injected scripts load.
document.querySelectorAll('[data-qur-mattress-range]').forEach(initQuncelUltraReference);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-qur]').forEach(initQuncelUltraReference);
});

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('[data-qur]') || (event.target.matches?.('[data-qur]') ? event.target : null);
  initQuncelUltraReference(root);
});
